/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoryResponse } from '../../models/company-category-response';

export interface GetCompanyCategory$Params {
  id: number;
}

export function getCompanyCategory(http: HttpClient, rootUrl: string, params: GetCompanyCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyCategoryResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyCategory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyCategoryResponse>;
    })
  );
}

getCompanyCategory.PATH = '/api/editorial/company-category/{id}';
